import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i44657171__a" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i44657171__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "m20.133 10.662 1.94-1.963a.669.669 0 0 0 .142-.722.654.654 0 0 0-.605-.41h-3.656v6.19h3.656a.655.655 0 0 0 .605-.409.669.669 0 0 0-.141-.723l-1.94-1.963Zm-4.805-4.864H4.66c-.623 0-1.21-.351-1.47-.895h11.947a.612.612 0 0 0 .609-.617.613.613 0 0 0-.609-.616H3.157a1.532 1.532 0 0 1 1.417-.967H16.2a.659.659 0 0 0 .655-.663.66.66 0 0 0-.655-.664H4.67c-1.528 0-2.855 1.182-2.93 2.727a2.687 2.687 0 0 0-.003.223.591.591 0 0 0-.002.036v15.254c0 1.5 1.118 2.783 2.507 2.963a.66.66 0 0 0 .166.021h10.92c.965 0 1.748-.792 1.748-1.768V7.567c0-.977-.783-1.769-1.747-1.769Zm-10.936 9.79c0-.246.198-.447.441-.447h2.792c.244 0 .441.2.441.447v.061a.444.444 0 0 1-.44.447H4.832c-.243 0-.44-.2-.44-.447v-.06Zm5.237 2.899a.444.444 0 0 1-.442.446H4.833c-.243 0-.44-.2-.44-.446v-.061c0-.247.197-.447.44-.447h4.354c.244 0 .442.2.442.447v.06Zm-.472-5.228H4.863a.475.475 0 0 1-.47-.478c0-.263.21-.477.47-.477h4.294c.26 0 .472.214.472.477a.475.475 0 0 1-.472.478Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "newInfo"}) } }